  
import Wrapper from "./src/app/wrapper";
export const wrapRootElement = Wrapper;